export type Customer = {
  id: number;
  name: customerType;
  apiBackend: string;
  domain: string;
  userSuffix: string;
  enabled: boolean;
};

export type customerType =
  | 'marval'
  | 'buenvivir'
  | 'prodesa'
  | 'mayasoft'
  | 'gmail'
  | 'cusezar'
  | 'alcabama'
  | 'jaramillo_mora'
  | 'capital'
  | 'capital_bogota'
  | 'triada'
  | 'logicem'
  | 'fl_colombia'
  | 'bolivar_cali'
  | 'job_and_talent'
  | 'oikos'
  | 'bolivar_bogota'
  | 'medicall_th'
  | 'notaria_quinta_bogota'
  | 'notaria_tercera_bogota';

export const Customers = [
  'marval',
  'buenvivir',
  'prodesa',
  'mayasoft',
  'gmail',
  'cusezar',
  'alcabama',
  'jaramillo_mora',
  'capital',
  'capital_bogota',
  'triada',
  'logicem',
  'fl_colombia',
  'bolivar_cali',
  'bolivar_bogota',
  'job_and_talent',
  'oikos',
  'medicall_th',
  'notaria_quinta_bogota',
  'notaria_tercera_bogota',
];
